import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Common from "../../../helper/common";
import {
    SearchTypeEnum,
    TermsnConditionTypeEnum,
    RoleEnum,
} from "../../../constants/appConstant";
import { Button } from "../../../components/ui/button";
import { Icon } from "@iconify/react";
import { AppSelect, AppInput } from "../../../components/appComponents";
import AdvanceTable from "../../../components/advanceTable";
import AddEditRoutes from "./addRoutes";
import ReorderRoutes from "./reorderRoutes";
import { Card, CardContent, CardHeader } from "../../../components/ui/card";

const AddRoutes = () => {
    const navigate = useNavigate();
    let [data, setData] = useState({});
    let [search, setSearch] = useState(null);
    const [open, setOpen] = useState(false);
    const [reorderOpen, setReorderOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [menuTabs, setMenuTabs] = useState([]);
    const [defaultPermissionsList, setDefaultPermissionsList] = useState([]);

    // Filter states
    const [filters, setFilters] = useState({
        menutab: null,
        ispremium: null,
        isdisplayon: null,
        isclubspecific: null,
        isnewfeature: null,
    });

    // Store original data for filtering
    const [originalData, setOriginalData] = useState([]);

    useEffect(() => {
        getMenuTabs();
        getRoutes();
        //getClubAccount();
    }, []);

    const getMenuTabs = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetMenuTabs"
            );
            const data = response?.data ?? [];
            setMenuTabs(data);
        });
    };

    const getRoutes = async (searchParams = null) => {
        try {
            let isRoutePage = true;
            if (searchParams && typeof searchParams === 'object' && searchParams.search) {
                // This is a search request from AdvanceTable
                // console.log("Search request:", searchParams);
                // You can handle search logic here if needed
            }
            const response = await Common.ApiService.getInstance().request(
                `GetDefaultMasterPermissions?isRoutePage=${isRoutePage}`,
                "GET"
            );
            if (response?.data?.length) {
                let _data = response?.data.map((item) => ({
                    id: item.id,
                    name: item.name,
                    endpoint: item.endpoint ?? "-",
                    controller: item.controller ?? "-",
                    action: item.action ?? "-",
                    icon: item.icon,
                    icontype: item.icontype ?? "-",
                    parentId: item.parentId,
                    parentname: item.parentname ?? "-",
                    isActive: item.isActive,
                    isdefaultview: item.isdefaultview,
                    isclubspecific: item.isclubspecific === true
                        ? "Yes"
                        : item.isclubspecific === false
                            ? "No"
                            : "-",
                    isdisplayon: item.isdisplayon === true
                        ? "Yes"
                        : item.isdisplayon === false
                            ? "No"
                            : "-",
                    ispremium: item.ispremium === true
                        ? "Yes"
                        : item.ispremium === false
                            ? "No"
                            : "-",
                    isnewfeature: item.isnewfeature === true
                        ? "Yes"
                        : item.isnewfeature === false
                            ? "No"
                            : "-",
                    menutab: item.menutab ?? "-",
                    menutabid: item.menutabid,
                    premiumallowed: item.premiumallowed,
                    sortOrder: item.sortOrder,
                    type: item.type,
                    children: item.children ?? [],
                }));

                setOriginalData(_data);
                applyFilters(_data);
                setDefaultPermissionsList(response.data);
                //console.log(_data, "defaultPermissionList");
            } else {
                setOriginalData([]);
                setData({ data: [] });
                //alert("No terms found");
            }
        } catch (error) {
            console.error("Error fetching terms and conditions:", error);
        }
    };

    // Apply filters to data
    const applyFilters = (dataToFilter = null) => {
        const sourceData = dataToFilter || originalData;

        if (!sourceData || sourceData.length === 0) {
            setData({ data: [] });
            return;
        }

        const filteredData = sourceData.filter((item) => {
            const byMenuTab =
                filters.menutab === null || item.menutab === filters.menutab;
            const byPremium =
                filters.ispremium === null || item.ispremium === filters.ispremium;
            const byDisplayOn =
                filters.isdisplayon === null ||
                item.isdisplayon === filters.isdisplayon;
            const byClubSpecific =
                filters.isclubspecific === null ||
                item.isclubspecific === filters.isclubspecific;
            const byNewFeature =
                filters.isnewfeature === null ||
                item.isnewfeature === filters.isnewfeature;

            return byMenuTab && byPremium && byDisplayOn && byClubSpecific && byNewFeature;
        });

        setData({ data: filteredData });
    };

    // Handle filter changes
    const handleFilterChange = (filterKey, value) => {
        const newFilters = { ...filters, [filterKey]: value };
        setFilters(newFilters);
        applyFiltersWithNewFilters(newFilters);
    };

    // Apply filters with new filter values
    const applyFiltersWithNewFilters = (newFilters) => {
        if (!originalData || originalData.length === 0) {
            setData({ data: [] });
            return;
        }

        const filteredData = originalData.filter((item) => {
            const byMenuTab =
                newFilters.menutab === null || item.menutab === newFilters.menutab;
            const byPremium =
                newFilters.ispremium === null ||
                item.ispremium === newFilters.ispremium;
            const byDisplayOn =
                newFilters.isdisplayon === null ||
                item.isdisplayon === newFilters.isdisplayon;
            const byClubSpecific =
                newFilters.isclubspecific === null ||
                item.isclubspecific === newFilters.isclubspecific;
            const byNewFeature =
                newFilters.isnewfeature === null ||
                item.isnewfeature === newFilters.isnewfeature;

            return byMenuTab && byPremium && byDisplayOn && byClubSpecific && byNewFeature;
        });

        setData({ data: filteredData });
    };

    // Reset all filters
    const resetFilters = () => {
        setFilters({
            menutab: null,
            ispremium: null,
            isdisplayon: null,
            isclubspecific: null,
            isnewfeature: null,
        });
        setData({ data: originalData });
    };

    const columns = [
        { title: "ID", type: "number", isVisible: false, key: "id" },
        { title: "Name", type: "text", isVisible: true, key: "name" },
        { title: "Endpoint", type: "text", isVisible: true, key: "endpoint" },
        { title: "Controller", type: "text", isVisible: false, key: "controller" },
        { title: "Action", type: "text", isVisible: false, key: "action" },
        { title: "Parent Name", type: "text", isVisible: true, key: "parentname" },
        { title: "Icon", type: "text", isVisible: true, key: "icon" },
        { title: "Icon Type", type: "text", isVisible: false, key: "icontype" },
        { title: "Sort Order", type: "number", isVisible: false, key: "sortOrder" },
        { title: "Type", type: "number", isVisible: false, key: "type" },
        { title: "Menu Tab", type: "text", isVisible: true, key: "menutab" },
        { title: "Premium", type: "number", isVisible: true, key: "ispremium" },
        { title: "New Feature", type: "number", isVisible: true, key: "isnewfeature" },
        { title: "Display On", type: "int", isVisible: true, key: "isdisplayon" },
        { title: "Club Specific", type: "text", isVisible: true, key: "isclubspecific" },
        { title: "Default View", type: "text", isVisible: false, key: "isdefaultview" },
        { title: "Active", type: "text", isVisible: false, key: "isActive" },
    ];

    const _handleDelete = async (id) => {
        const isConfirmed = await Common.SweetAlert.confirmation(
            "Are you sure want to delete this endpoint??",
            "Delete Endpoint"
        );

        if (isConfirmed) {
            let resp = await Common.ApiService.getInstance().request(
                `DeleteEndpoints?id=${id}`,
                {},
                "Delete"
            );

            Common.SweetAlert.alert(resp.message, "success");

            setTimeout(() => {
                getRoutes();
            }, 500);
        }
    };

    const handleEdit = (item) => {
        setEditId(item.id);
        setSelectedItem(item);
        setOpen(true);
    };

    const handleClose = () => {
        setEditId(null);
        getRoutes();
    };

    const actions = [
        {
            type: "edit",
            onClick: handleEdit,
        },
        {
            type: "delete",
            onClick: (val) => _handleDelete(val.id),
        },
    ];

    return (
        <>
            {/* Navigation & Filters Card Section */}
            <Card className="mb-6 shadow-md border border-border/50 bg-gradient-to-br from-card to-card/95">
                <CardHeader className="pb-3 border-b border-border/50 bg-gradient-to-r from-primary/5 via-transparent to-transparent">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div className="flex items-center gap-2">
                            <div className="p-2 rounded-lg bg-primary/10 text-primary">
                                <Icon icon="mdi:route" className="h-5 w-5" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-foreground">Routes Management</h3>
                                <p className="text-sm text-muted-foreground">Manage and filter your application routes</p>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <Button
                                onClick={() => {
                                    setReorderOpen(true);
                                }}
                                className="h-10 px-4 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary shadow-sm transition-all duration-200 flex items-center gap-2"
                                variant="default"
                            >
                                <Icon icon="mdi:menu-swap" className="h-4 w-4" />
                                Manage Routes & Menu Tabs
                            </Button>
                        </div>
                    </div>
                </CardHeader>
                
                <CardContent className="pt-6">
                    {/* Filters Section */}
                    <div className="space-y-4 px-4 pb-4">
                        <div className="flex items-center gap-2 mb-4">
                            <Icon icon="mdi:filter-variant" className="h-5 w-5 text-primary" />
                            <h4 className="text-sm font-semibold text-foreground">Filter Options</h4>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                            <div className="space-y-2">
                                <AppSelect
                                    value={filters.menutab}
                                    label="Menu Tab"
                                    className="mb-0"
                                    data={[
                                        { id: null, name: "All" },
                                        ...menuTabs.map((tab) => ({ id: tab.name, name: tab.name })),
                                    ]}
                                    onChange={(value) => handleFilterChange("menutab", value)}
                                />
                            </div>
                            <div className="space-y-2">
                                <AppSelect
                                    value={filters.ispremium}
                                    label="Premium"
                                    className="mb-0"
                                    data={[
                                        { id: null, name: "All" },
                                        { id: "Yes", name: "Yes" },
                                        { id: "No", name: "No" },
                                    ]}
                                    onChange={(value) => handleFilterChange("ispremium", value)}
                                />
                            </div>
                            <div className="space-y-2">
                                <AppSelect
                                    value={filters.isdisplayon}
                                    label="Display On"
                                    className="mb-0"
                                    data={[
                                        { id: null, name: "All" },
                                        { id: "Yes", name: "Yes" },
                                        { id: "No", name: "No" },
                                    ]}
                                    onChange={(value) => handleFilterChange("isdisplayon", value)}
                                />
                            </div>
                            <div className="space-y-2">
                                <AppSelect
                                    value={filters.isclubspecific}
                                    label="Club Specific"
                                    className="mb-0"
                                    data={[
                                        { id: null, name: "All" },
                                        { id: "Yes", name: "Yes" },
                                        { id: "No", name: "No" },
                                    ]}
                                    onChange={(value) => handleFilterChange("isclubspecific", value)}
                                />
                            </div>
                            <div className="space-y-2">
                                <AppSelect
                                    value={filters.isnewfeature}
                                    label="New Feature"
                                    className="mb-0"
                                    data={[
                                        { id: null, name: "All" },
                                        { id: "Yes", name: "Yes" },
                                        { id: "No", name: "No" },
                                    ]}
                                    onChange={(value) => handleFilterChange("isnewfeature", value)}
                                />
                            </div>
                        </div>
                        <div className="flex justify-end pt-2 border-t border-border/50">
                            <Button 
                                onClick={resetFilters} 
                                variant="outline"
                                className="h-9 px-4 hover:bg-destructive/10 hover:text-destructive hover:border-destructive/50 transition-all duration-200"
                            >
                                <Icon icon="mdi:refresh" className="mr-2 h-4 w-4" />
                                Reset Filters
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <AdvanceTable
                title={"Routes"}
                columns={columns.filter((item) => item.isVisible)}
                data={data}
                getData={getRoutes}
                addButton={() => (
                    <Button
                        onClick={() => {
                            setEditId(null);
                            setOpen(true);
                            setSelectedItem(null);
                        }}
                    >
                        + Add
                    </Button>
                )}
                showAddButton
                actionButtons={actions}
                searchInputClassName="custom-search-mobile"
                search={SearchTypeEnum.Server_Search}
            />
            {/* Initialize the dialog */}
            <AddEditRoutes
                id={editId}
                open={open}
                setOpen={setOpen}
                onClose={handleClose}
                selectedItem={selectedItem}
                menuTabs={menuTabs}
                defaultPermissionList={defaultPermissionsList}
            />

            {/* Reorder Routes Dialog */}
            <ReorderRoutes
                open={reorderOpen}
                setOpen={setReorderOpen}
                onClose={() => setReorderOpen(false)}
                routes={defaultPermissionsList}
                menuTabs={menuTabs}
                onReorder={getRoutes}
            />
        </>
    );
};
export default AddRoutes;
